import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const cardManagementSlide = createSlice({
    name: "cardManagement",
    initialState: {
        page: 0,
        pageCount: 0,
        success: false,
        fail: false,
        listData: null,
        detailData: null,
        responseData: null,
        errorDetailData: null,
        summaryData: null,
        totalRow: 0,

        // Generate batch
        generateBatchSuccess: false,
        generateBatchFail: false,
        generateBatchResponseData: null,

        // Assign cards to retailer
        assignSuccess: false,
        assignFail: false,
        assignReponseData: null,

        // Unassign cards from retailer
        unassignSuccess: false,
        unassignFail: false,
        unassignResponseData: null,

        // Void a whole batch
        voidBatchSuccess: false,
        voidBatchFail: false,
        voidBatchResponseData: null,

        // Reduce batch quantity (voids cards from the tail)
        reduceQuantitySuccess: false,
        reduceQuantityFail: false,
        reduceQuantityResponseData: null,

        // Batches with unassigned cards (for assign dialog)
        batchesWithUnassigned: null,

        // Batch assignment info (for assign dialog)
        batchAssignmentInfo: null,
        batchAssignmentInfoLoading: false,

        batchPage: 0,
        batchPageCount: 0,
        batchListData: null,

        downloadQRSuccess: false,
        downloadQRFail: false,
        // downloadQRReponseData: null,

        // Batch cards (individual cards in a batch)
        batchCardsData: null,
        batchCardsPage: 0,
        batchCardsPageCount: 0,
        batchCardsLoading: false,
    },
    reducers: {
        doGetCardManagementListSuccess: (state, action) => {
            state.listData = action.payload.data;
            state.page = action.payload?.current_page;
			state.pageCount = action.payload?.page_count;
			state.totalRow = action.payload?.total_row;
        },
        doGetCardManagementListFail: (state, action) => {
            state.listData = null;
            state.page = 0;
			state.pageCount = 0;
			state.totalRow = 0;
        },
        doGetCardManagementSummarySuccess: (state, action) => {
            state.summaryData = action.payload?.data;
        },
        doGetCardManagementSummaryFail: (state, action) => {
            state.summaryData = null;
        },

        doGetCardManagementDetailSuccess: (state, action) => {
            state.detailData = action.payload.data;
        },
        doGetCardManagementDetailFail: (state, action) => {
            state.detailData = null;
        },

        doAddCardManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
			state.responseData = action.payload;
        },
        doAddCardManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        doUpdateCardManagementSuccess: (state, action) => {
            state.success = true;
            state.fail = false;
        },
        doUpdateCardManagementFail: (state, action) => {
            state.success = false;
            state.fail = true;
			state.errorDetailData = action.payload;
        },

        // Generate batch reducers
        doGenerateBatchSuccess: (state, action) => {
            state.generateBatchSuccess = true;
            state.generateBatchFail = false;
            state.generateBatchResponseData = action.payload;
        },
        doGenerateBatchFail: (state, action) => {
            state.generateBatchSuccess = false;
            state.generateBatchFail = true;
            state.errorDetailData = action.payload;
        },

        // Assign cards to retailer reducers
        doAssignCardManagementSuccess: (state, action) => {
            state.assignSuccess = true;
            state.assignFail = false;
			state.assignReponseData = action.payload;
        },
        doAssignCardManagementFail: (state, action) => {
            state.assignSuccess = false;
            state.assignFail = true;
			state.errorDetailData = action.payload;
        },

        // Unassign cards from retailer reducers
        doUnassignCardManagementSuccess: (state, action) => {
            state.unassignSuccess = true;
            state.unassignFail = false;
            state.unassignResponseData = action.payload;
        },
        doUnassignCardManagementFail: (state, action) => {
            state.unassignSuccess = false;
            state.unassignFail = true;
            state.errorDetailData = action.payload;
        },

        // Void batch reducers
        doVoidBatchSuccess: (state, action) => {
            state.voidBatchSuccess = true;
            state.voidBatchFail = false;
            state.voidBatchResponseData = action.payload;
        },
        doVoidBatchFail: (state, action) => {
            state.voidBatchSuccess = false;
            state.voidBatchFail = true;
            state.errorDetailData = action.payload;
        },

        // Reduce batch quantity reducers
        doReduceBatchQuantitySuccess: (state, action) => {
            state.reduceQuantitySuccess = true;
            state.reduceQuantityFail = false;
            state.reduceQuantityResponseData = action.payload;
        },
        doReduceBatchQuantityFail: (state, action) => {
            state.reduceQuantitySuccess = false;
            state.reduceQuantityFail = true;
            state.errorDetailData = action.payload;
        },

        // Batches with unassigned cards
        doGetBatchesWithUnassignedSuccess: (state, action) => {
            // Handle both { data: [...] } and direct array response
            const data = action.payload?.data;
            state.batchesWithUnassigned = Array.isArray(data) ? data : [];
        },
        doGetBatchesWithUnassignedFail: (state, action) => {
            state.batchesWithUnassigned = [];
        },

        // Batch assignment info
        doGetBatchAssignmentInfoRequest: (state) => {
            state.batchAssignmentInfoLoading = true;
        },
        doGetBatchAssignmentInfoSuccess: (state, action) => {
            state.batchAssignmentInfo = action.payload.data;
            state.batchAssignmentInfoLoading = false;
        },
        doGetBatchAssignmentInfoFail: (state, action) => {
            state.batchAssignmentInfo = null;
            state.batchAssignmentInfoLoading = false;
        },

        doGetBatchCardManagementListSuccess: (state, action) => {
            state.batchListData = action.payload.data;
            state.batchPage = action.payload.data?.current_page;
			state.batchPageCount = action.payload.data?.page_count;
        },
        doGetBatchCardManagementListFail: (state, action) => {
            state.batchListData = null;
            state.batchPage = 0;
			state.batchPageCount = 0;
        },

        doDownloadQRCodeCardSuccess: (state, action) => {
            state.downloadQRSuccess = true;
            state.downloadQRFail = false;
			// state.downloadQRReponseData = action.payload;
        },
        doDownloadQRCodeCardFail: (state, action) => {
            state.downloadQRSuccess = false;
            state.downloadQRFail = true;
			state.errorDetailData = action.payload;
        },

        resetCardManagementStateSuccess: (state, action) => {
            state.success = action.payload;
            state.fail = action.payload;
			state.errorDetailData = null;
            state.generateBatchSuccess = action.payload;
            state.generateBatchFail = action.payload;
            state.generateBatchResponseData = null;
            state.assignSuccess = action.payload;
            state.assignFail = action.payload;
            state.assignReponseData = null;
            state.unassignSuccess = action.payload;
            state.unassignFail = action.payload;
            state.unassignResponseData = null;
            state.voidBatchSuccess = action.payload;
            state.voidBatchFail = action.payload;
            state.voidBatchResponseData = null;
            state.reduceQuantitySuccess = action.payload;
            state.reduceQuantityFail = action.payload;
            state.reduceQuantityResponseData = null;
            state.downloadQRSuccess = action.payload;
            state.downloadQRFail = action.payload;
            state.batchAssignmentInfo = null;
            // state.downloadQRReponseData = null;
        },

        resetCardManagementSuccess: (state, action) => {
            state.detailData = null;
        },

        doGetBatchCardsRequest: (state, action) => {
            state.batchCardsLoading = true;
        },
        doGetBatchCardsSuccess: (state, action) => {
            state.batchCardsData = action.payload;
            state.batchCardsPage = action.payload?.current_page || 1;
            state.batchCardsPageCount = action.payload?.page_count || 0;
            state.batchCardsLoading = false;
        },
        doGetBatchCardsFail: (state, action) => {
            state.batchCardsData = null;
            state.batchCardsPage = 0;
            state.batchCardsPageCount = 0;
            state.batchCardsLoading = false;
        },
    },
});

export const doGetCardManagementList = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/card-management?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetCardManagementListSuccess(response.data));
    } catch (error) {
        dispatch(doGetCardManagementListFail(error.response));
    }
};

export const doGetCardManagementSummary = () => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/summary`;

        const response = await axios.get(url);
        dispatch(doGetCardManagementSummarySuccess(response.data));
    } catch (error) {
        dispatch(doGetCardManagementSummaryFail(error.response));
    }
};

export const doGetCardManagementDetail = (param) => async (dispatch) => {
    try {
        let url = `/api/admin/card-management/${param.card_management_id}`;
       
        const response = await axios.get(url);
        dispatch(doGetCardManagementDetailSuccess(response.data));
    } catch (error) {
        dispatch(doGetCardManagementDetailFail(error.response));
    }
};

export const doAddCardManagement = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management`;

        const response = await axios.post(url, param);
        dispatch(doAddCardManagementSuccess(response.data));
    } catch (error) {
        dispatch(doAddCardManagementFail(error.response));
    }
};

export const doUpdateCardManagement = (param, card_management_id) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/${card_management_id}`;

        const response = await axios.put(url, param);
        dispatch(doUpdateCardManagementSuccess(response.data));
    } catch (error) {
        dispatch(doUpdateCardManagementFail(error.response));
    }
};

// Generate batch (cards only, no retailer)
export const doGenerateBatch = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/generate-batch`;

        const response = await axios.post(url, param);
        dispatch(doGenerateBatchSuccess(response.data));
    } catch (error) {
        dispatch(doGenerateBatchFail(error.response));
    }
};

// Assign cards to retailer (range-based)
export const doAssignCardsToRetailer = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/assign-cards-to-retailer`;

        const response = await axios.post(url, param);
        dispatch(doAssignCardManagementSuccess(response.data));
    } catch (error) {
        dispatch(doAssignCardManagementFail(error.response));
    }
};

// Unassign cards from retailer (range-based)
export const doUnassignCardsFromRetailer = (param) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/unassign-cards-from-retailer`;

        const response = await axios.post(url, param);
        dispatch(doUnassignCardManagementSuccess(response.data));
    } catch (error) {
        dispatch(doUnassignCardManagementFail(error.response));
    }
};

// Void a whole batch: retires every uncommitted card and takes it out of service
export const doVoidBatch = (batchId) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/batch/${batchId}`;

        const response = await axios.delete(url);
        dispatch(doVoidBatchSuccess(response.data));
    } catch (error) {
        dispatch(doVoidBatchFail(error.response));
    }
};

// Reduce a batch's quantity (voids cards from the tail)
export const doReduceBatchQuantity = (batchId, quantity) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/batch/${batchId}/reduce-quantity`;

        const response = await axios.put(url, { quantity });
        dispatch(doReduceBatchQuantitySuccess(response.data));
    } catch (error) {
        dispatch(doReduceBatchQuantityFail(error.response));
    }
};

// Get batches with unassigned cards (for assign dialog dropdown)
export const doGetBatchesWithUnassigned = () => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/batches-with-unassigned`;

        const response = await axios.get(url);
        console.log('API batches-with-unassigned response:', response.data);
        dispatch(doGetBatchesWithUnassignedSuccess(response.data));
    } catch (error) {
        console.error('API batches-with-unassigned error:', error);
        dispatch(doGetBatchesWithUnassignedFail(error.response));
    }
};

// Get batch assignment info (for assign dialog)
export const doGetBatchAssignmentInfo = (batch_id) => async (dispatch) => {
    try {
        dispatch(doGetBatchAssignmentInfoRequest());

        const url = `/api/admin/card-management/batch/${batch_id}/assignment-info`;

        const response = await axios.get(url);
        dispatch(doGetBatchAssignmentInfoSuccess(response.data));
    } catch (error) {
        dispatch(doGetBatchAssignmentInfoFail(error.response));
    }
};

export const doGetBatchCardManagementList = (param, card_product_id) => async (dispatch) => {
    try {
        let url = `/api/admin/card-management/${card_product_id}/batch?page=${param.page}&size=${param.limit}`;
        if(param.filter) {
            url += `&filter=${encodeURIComponent(param.filter)}`;
        }

        const response = await axios.get(url);
        dispatch(doGetBatchCardManagementListSuccess(response.data));
    } catch (error) {
        dispatch(doGetBatchCardManagementListFail(error.response));
    }
};

// format: "excel" -> .xlsx card data, "images" -> .zip of printable QR PNGs
// opts: { signal, onProgress } — signal is an AbortController.signal for cancel;
// onProgress({ loaded, total }) fires as bytes arrive (total is 0 for the streamed
// images zip, which has no Content-Length — the caller estimates it from card count).
export const doDownloadQRCodeCard = (batch_id, cardName, retailName, format = "excel", opts = {}) => async (dispatch) => {
    try {
        const url = `/api/admin/card-management/download-qr-codes/${batch_id}?format=${format}`;

        const response = await axios.get(url, {
            responseType: 'blob',
            signal: opts.signal,
            onDownloadProgress: opts.onProgress
                ? (e) => opts.onProgress({ loaded: e.loaded || 0, total: e.total || 0 })
                : undefined,
        });

        const isImages = format === "images";
        const suffix = isImages ? "QR_Codes" : "Cards";
        const ext = isImages ? "zip" : "xlsx";

        // Trigger download immediately
        const url2 = window.URL.createObjectURL(response?.data);
        const link = document.createElement('a');
        link.href = url2;
        link.download = retailName ? `${cardName}_${retailName}_${suffix}.${ext}` : `${cardName}_${suffix}.${ext}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url2);

        dispatch(doDownloadQRCodeCardSuccess());
    } catch (error) {
        // A user-initiated cancel is not a failure — only report real errors.
        if (!axios.isCancel(error)) {
            dispatch(doDownloadQRCodeCardFail(error.response));
        }
        throw error; // let the caller distinguish cancel vs error and update the UI
    }
};

export const resetCardManagementState = () => async (dispatch) => {
    dispatch(resetCardManagementStateSuccess(false));
};

export const resetCardManagement = () => async (dispatch) => {
    dispatch(resetCardManagementSuccess(false));
};

export const doGetBatchCards = (batch_id, param) => async (dispatch) => {
    try {
        dispatch(doGetBatchCardsRequest());

        let url = `/api/admin/card-management/batch/${batch_id}/cards?page=${param.page}&size=${param.limit}`;
        if (param.status) {
            url += `&status=${param.status}`;
        }
        if (param.start_date) url += `&start_date=${param.start_date}`;
        if (param.end_date) url += `&end_date=${param.end_date}`;

        const response = await axios.get(url);
        dispatch(doGetBatchCardsSuccess(response.data));
    } catch (error) {
        dispatch(doGetBatchCardsFail(error.response));
    }
};

export const {
    doGetCardManagementListSuccess,
    doGetCardManagementListFail,

    doGetCardManagementSummarySuccess,
    doGetCardManagementSummaryFail,

    doGetCardManagementDetailSuccess,
    doGetCardManagementDetailFail,

    doAddCardManagementSuccess,
    doAddCardManagementFail,

    doUpdateCardManagementSuccess,
    doUpdateCardManagementFail,

    doGenerateBatchSuccess,
    doGenerateBatchFail,

    doAssignCardManagementSuccess,
    doAssignCardManagementFail,

    doUnassignCardManagementSuccess,
    doUnassignCardManagementFail,

    doReduceBatchQuantitySuccess,
    doReduceBatchQuantityFail,

    doVoidBatchSuccess,
    doVoidBatchFail,

    doGetBatchesWithUnassignedSuccess,
    doGetBatchesWithUnassignedFail,

    doGetBatchAssignmentInfoRequest,
    doGetBatchAssignmentInfoSuccess,
    doGetBatchAssignmentInfoFail,

    doGetBatchCardManagementListSuccess,
    doGetBatchCardManagementListFail,

    doDownloadQRCodeCardSuccess,
    doDownloadQRCodeCardFail,

    doGetBatchCardsRequest,
    doGetBatchCardsSuccess,
    doGetBatchCardsFail,

    resetCardManagementStateSuccess,
    resetCardManagementSuccess,
} = cardManagementSlide.actions;

export const getCardManagementList = (state) => state.cardManagement?.listData;
export const getCardManagementListPage = (state) => state.cardManagement?.page;
export const getCardManagementListPageCount = (state) => state.cardManagement?.pageCount;
export const getCardManagementListTotal = (state) => state.cardManagement?.totalRow;
export const getCardManagementSummary = (state) => state.cardManagement?.summaryData;

export const getCardManagementDetail = (state) => state.cardManagement?.detailData;
export const getCardManagementErrorDetailData = (state) => state.cardManagement?.errorDetailData;

export const getAddCardManagementSuccess = (state) => state.cardManagement?.success;
export const getAddCardManagementFail = (state) => state.cardManagement?.fail;
export const getAddCardManagementResponseData = (state) => state.cardManagement?.responseData;

export const getGenerateBatchSuccess = (state) => state.cardManagement?.generateBatchSuccess;
export const getGenerateBatchFail = (state) => state.cardManagement?.generateBatchFail;
export const getGenerateBatchResponseData = (state) => state.cardManagement?.generateBatchResponseData;

export const getAssignCardManagementSuccess = (state) => state.cardManagement?.assignSuccess;
export const getAssignCardManagementFail = (state) => state.cardManagement?.assignFail;
export const getAssignCardManagementResponseData = (state) => state.cardManagement?.assignReponseData;

export const getUnassignCardManagementSuccess = (state) => state.cardManagement?.unassignSuccess;
export const getUnassignCardManagementFail = (state) => state.cardManagement?.unassignFail;
export const getUnassignCardManagementResponseData = (state) => state.cardManagement?.unassignResponseData;

export const getVoidBatchSuccess = (state) => state.cardManagement?.voidBatchSuccess;
export const getVoidBatchFail = (state) => state.cardManagement?.voidBatchFail;
export const getVoidBatchResponseData = (state) => state.cardManagement?.voidBatchResponseData;

export const getReduceBatchQuantitySuccess = (state) => state.cardManagement?.reduceQuantitySuccess;
export const getReduceBatchQuantityFail = (state) => state.cardManagement?.reduceQuantityFail;
export const getReduceBatchQuantityResponseData = (state) => state.cardManagement?.reduceQuantityResponseData;

export const getBatchesWithUnassigned = (state) => state.cardManagement?.batchesWithUnassigned;
export const getBatchAssignmentInfo = (state) => state.cardManagement?.batchAssignmentInfo;
export const getBatchAssignmentInfoLoading = (state) => state.cardManagement?.batchAssignmentInfoLoading;

export const getBatchCardManagementList = (state) => state.cardManagement?.batchListData;
export const getBatchCardManagementListPage = (state) => state.cardManagement?.batchPage;
export const getBatchCardManagementListPageCount = (state) => state.cardManagement?.batchPageCount;

export const getDownloadQRSuccess = (state) => state.cardManagement?.downloadQRSuccess;
export const getDownloadQRFail = (state) => state.cardManagement?.downloadQRFail;
// export const getDownloadQRReponseData = (state) => state.cardManagement?.downloadQRReponseData;

export const getBatchCardsData = (state) => state.cardManagement?.batchCardsData;
export const getBatchCardsPage = (state) => state.cardManagement?.batchCardsPage;
export const getBatchCardsPageCount = (state) => state.cardManagement?.batchCardsPageCount;
export const getBatchCardsLoading = (state) => state.cardManagement?.batchCardsLoading;

export default cardManagementSlide.reducer;
